import React, { useState } from "react";

import "./Layout.scss";

import divider from "../../assets/img/divider.svg";
import notificationBell from "../../assets/img/notificationBell.svg";

import userIcon from "../../assets/img/Group 23364.svg";
import searchIcon from "../../assets/img/Union 15.svg";
import mic1 from "../../assets/img/Google_mic.png";
import mic from "../../assets/img/Google_mic_2.png";
import { useHistory } from "react-router-dom";

function SearchLayout({ setSearchText }) {
  //const [open, setOpen] = useState(0);
  const [search, setSearch] = useState("");

  const history = useHistory();

  return (
    <>
      <div className="content-header-right content-search ">
        <div className="content-header-input-container-search">
          <input
            type="text"
            className="content-header-input content-header-input-width"
            placeholder="Type here to search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              //setSearchText(e.target.value);
              //history.replace("/search?" + search);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
              //if(search.length>=3){
              setSearchText(search);
                history.push("/search?" + search);
              }
            }}
          />
           <button  className="content-header-input-submit content-float">
          <img src={mic} alt="user icon" height="20" style={{ marginTop: "5px" }} />
        </button>
          <button
            type="submit"
            className="content-header-input-submit content-float"
            style={{ marginTop: "5px" }}
            onClick={() => {
              setSearchText(search);
              history.replace("/search?" + search);
            }}
          >
            <img src={searchIcon} alt="" />
          </button>
          
          <img src={divider} alt="divider" height="35" className="content-float" />
         
        </div>
        <button>
          <img src={notificationBell} alt="notification icon" height="30" style={{ marginTop: "5px" }} />
        </button>
        <button>
          <img src={userIcon} alt="user icon" height="30" style={{ marginTop: "5px" }} />
        </button>
        {/* <button>
          <img src={mic} alt="user icon" height="30" style={{ marginTop: "5px" }} />
        </button> */}
      </div>
    </>
  );
}
export default SearchLayout;
